import React, { useEffect, useState } from "react";
import { Bell } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import {
  Popover, PopoverTrigger, PopoverContent,
} from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export default function NotificationBell() {
  const [items, setItems] = useState([]);
  const unread = items.filter((i) => !i.read).length;

  const load = async () => {
    try {
      const { data } = await api.get("/notifications");
      setItems(data);
    } catch {}
  };

  useEffect(() => {
    load();
    const id = setInterval(load, 20000);
    return () => clearInterval(id);
  }, []);

  const readAll = async () => {
    await api.post("/notifications/read-all");
    load();
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          className="relative h-9 w-9 inline-flex items-center justify-center rounded-sm hover:bg-zinc-100 dark:hover:bg-zinc-900 transition-colors"
          data-testid="notifications-button"
          aria-label="Notifications"
        >
          <Bell size={18} weight="regular" />
          {unread > 0 && (
            <span
              data-testid="notifications-unread-count"
              className="absolute -top-1 -right-1 text-[10px] font-bold px-1 min-w-[16px] h-4 inline-flex items-center justify-center bg-[#E1252A] text-white rounded-sm"
            >
              {unread}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0 rounded-sm" data-testid="notifications-panel">
        <div className="flex items-center justify-between px-3 py-2 border-b border-border">
          <div className="text-xs uppercase tracking-[0.2em]">Notifications</div>
          {items.length > 0 && (
            <Button variant="ghost" size="sm" onClick={readAll} data-testid="notifications-mark-read">
              Mark all read
            </Button>
          )}
        </div>
        <div className="max-h-96 overflow-y-auto">
          {items.length === 0 && (
            <div className="p-6 text-sm text-zinc-500 text-center">You're all caught up.</div>
          )}
          {items.map((n) => (
            <Link
              to={n.link || "#"}
              key={n.notif_id}
              data-testid={`notification-item-${n.notif_id}`}
              className={`block px-3 py-2 border-b border-border hover:bg-zinc-50 dark:hover:bg-zinc-900 ${
                !n.read ? "bg-zinc-50/40 dark:bg-zinc-900/40" : ""
              }`}
            >
              <div className="text-sm font-medium">{n.title}</div>
              <div className="text-xs text-zinc-500 line-clamp-2">{n.body}</div>
              <div className="text-[10px] text-zinc-400 mt-1 uppercase tracking-wider">
                {new Date(n.created_at).toLocaleString()}
              </div>
            </Link>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
